<template>
    <v-card color="#F6F9FC" flat class="rounded-0 pt-6">
        <v-container>
            <v-row>
                <v-col cols="12" lg="3">
                    <DashboardSidebar></DashboardSidebar>
                </v-col>
                <v-col cols="12" lg="9">
                    <v-card flat class="buyed-panel pa-5">
                        <!-- 区块标题 + 筛选 -->
                        <div class="sec-head">
                            <div>
                                <h3 class="sec-title">{{ $t('购买记录') }}</h3>
                                <p class="sec-sub">{{ $t('查看你购买过的模板与订单') }}</p>
                            </div>
                            <div class="filter-bar">
                                <span class="filter-label">{{ $t('类型') }}：</span>
                                <v-select :items="statusItems" v-model="postParam.pay_status" outlined dense
                                    hide-details class="filter-select" color="#7331FF"
                                    @change="getlist"></v-select>
                            </div>
                        </div>
                        <v-divider class="my-4"></v-divider>

                        <!-- 订单列表 -->
                        <div v-if="buylist.length > 0" class="order-list">
                            <v-card flat class="order-card" v-for="(bitem,bidx) in buylist" :key="bidx"
                                @click="goDetail(bitem)" style="cursor:pointer">
                                <div class="order-head">
                                    <span class="order-sn">
                                        <v-icon size="14" class="mr-1" color="#7331FF">mdi-receipt-text</v-icon>
                                        {{$t('订单编号')}} {{ bitem.order_sn }}
                                    </span>
                                    <span class="order-time">
                                        <v-icon size="14" class="mr-1" color="#B0B9C7">mdi-clock-outline</v-icon>
                                        {{ bitem.updatetime }}
                                    </span>
                                    <span class="order-status" :class="bitem.type == 1 ? 'status-free' : 'status-paid'">
                                        <template v-if="bitem.type == 1">{{ $t('免费') }}</template>
                                        <template v-else>{{ $t('已支付') }}</template>
                                    </span>
                                </div>
                                <div class="order-body">
                                    <img :src="bitem.cover_img" alt="" class="order-cover" />
                                    <div class="order-info">
                                        <p class="order-name">{{ bitem.name }}</p>
                                        <p class="order-desc">{{ bitem.des }}</p>
                                    </div>
                                    <div class="order-price">
                                        <b v-if="bitem.type == 2" class="price-num">{{ bitem.pay_symbol }}{{ bitem.pay_money }}</b>
                                        <b v-else class="price-free">{{ $t('免费') }}</b>
                                    </div>
                                </div>
                            </v-card>
                        </div>
                        <div class="empty-state" v-else>
                            <img src="@/assets/images/loading/wusousuo.png" alt="" class="empty-img">
                            <p class="empty-text">{{ $t('暂无购买记录') }}</p>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>
<script>
import DashboardSidebar from '../../components/DashboardSidebar.vue'
export default {
    components: {
        DashboardSidebar
    },
    data() {
        return {
            menu: false,
            menu1: false,
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            buylist:[],
            statusList: [{
                text: '全部',
                value: '-1',

            },
            {
                text: '未支付',
                value: '0',

            },
            {
                text: '已支付',
                value: '1',

            }
            ],
            postParam:{
                pay_status:'1',
                current_page:1,
                page_number:50
            }
        }
    },
    mounted(){
        this.getlist();
    },
    computed: {
        // 筛选选项随语言即时翻译
        statusItems() {
            return this.statusList.map(s => ({ ...s, text: this.$t(s.text) }));
        }
    },
    methods:{
        getlist(){
            this.$api.template.order_list(this.postParam).then(res=>{
                if(res.status){
                    this.buylist=res.data.records;
                }
            })
        },
        // 点进详情才能「应用」到店铺：官方模板带 themes_id，店主发布的带 custom_themes_id
        goDetail(item){
            if(!item) return;
            if(item.custom_themes_id && Number(item.custom_themes_id) > 0){
                this.$router.push('/template-detail?custom_themes_id=' + item.custom_themes_id);
            }else if(item.themes_id){
                this.$router.push('/template-detail?themes_id=' + item.themes_id);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.buyed-panel {
    background: #fff;
    border: 1px solid #EEF1F5;
    border-radius: 14px;
    box-shadow: 0 4px 16px rgba(15, 52, 96, 0.04);

    .sec-head {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        gap: 16px;
        flex-wrap: wrap;

        .sec-title {
            font-size: 20px;
            font-weight: 800;
            color: #0F3460;
            margin-bottom: 2px;
        }

        .sec-sub {
            font-size: 12px;
            color: #8A96A8;
            margin-bottom: 0;
        }

        .filter-bar {
            display: flex;
            align-items: center;
            gap: 10px;

            .filter-label {
                font-size: 13px;
                color: #4A5568;
                font-weight: 600;
            }

            .filter-select {
                width: 140px;
            }
        }
    }

    .order-list {
        display: flex;
        flex-direction: column;
        gap: 14px;
    }

    .order-card {
        border: 1px solid #EEF1F5;
        border-radius: 14px;
        overflow: hidden;
        transition: box-shadow 0.2s;

        &:hover {
            box-shadow: 0 8px 24px rgba(115, 49, 255, 0.08);
        }

        .order-head {
            display: flex;
            align-items: center;
            gap: 18px;
            flex-wrap: wrap;
            background: #F6F8FC;
            padding: 10px 18px;
            border-bottom: 1px solid #EEF1F5;

            .order-sn {
                font-size: 13px;
                color: #0F3460;
                font-weight: 600;
                display: flex;
                align-items: center;
            }

            .order-time {
                font-size: 12px;
                color: #8A96A8;
                display: flex;
                align-items: center;
            }

            .order-status {
                margin-left: auto;
                font-size: 12px;
                font-weight: 700;
                padding: 3px 12px;
                border-radius: 12px;

                &.status-free {
                    color: #09bb07;
                    background: rgba(9, 187, 7, 0.10);
                }

                &.status-paid {
                    color: #7331FF;
                    background: rgba(115, 49, 255, 0.10);
                }
            }
        }

        .order-body {
            display: flex;
            align-items: center;
            gap: 16px;
            padding: 16px 18px;

            .order-cover {
                width: 108px;
                height: 132px;
                object-fit: cover;
                border-radius: 10px;
                border: 1px solid #EEF1F5;
                flex-shrink: 0;
            }

            .order-info {
                flex: 1;
                min-width: 0;

                .order-name {
                    font-size: 15px;
                    font-weight: 700;
                    color: #242939;
                    margin-bottom: 6px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .order-desc {
                    font-size: 13px;
                    color: #8A96A8;
                    margin-bottom: 0;
                    line-height: 1.6;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
            }

            .order-price {
                text-align: right;
                flex-shrink: 0;

                .price-num {
                    font-size: 18px;
                    color: #FF5252;
                }

                .price-free {
                    font-size: 15px;
                    color: #09bb07;
                }
            }
        }
    }

    .empty-state {
        text-align: center;
        padding: 60px 0;

        .empty-img {
            width: 120px;
            opacity: 0.7;
        }

        .empty-text {
            margin-top: 12px;
            color: #8A96A8;
            font-size: 14px;
        }
    }
}
</style>
